<template>
  <div class="flex surg-actions-container">
    <a
      v-show="surgStartDate && surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('cancelSurg', true)"
      style="margin-right: 0;"
    >
      <RescheduleIcon class="action-icon" />
      שיבוץ מחדש
    </a>
    <a
      v-show="surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('cancelSurg', false)"
    >
      <TrashIcon class="action-icon" /> מחיקת ניתוח
    </a>
    <a
      v-show="surgBeforeToday"
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('onEdit')"
    >
      <EditIcon class="action-icon" />עריכת ניתוח
    </a>
    <a
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('addDirectDocs')"
    >
      <FileAddIcon class="action-icon" />הוספת מסמכים
    </a>
    <a
      class="head-link-blue flex"
      href="javascript:void(0);"
      @click="$emit('patientRequests')"
    >
      <ClipboardListIcon class="action-icon" />בקשות מטופל
    </a>
    <router-link
      v-if="showIVF"
      class="head-link-blue flex"
      :to="`/cellosign/?surgId=${$route.params.id}`"
    >
      <FileCheckIcon class="action-icon" />טפסי הסכמה לפעולה
    </router-link>
    <router-link
      v-if="showExceptionCommittee"
      class="head-link-blue flex"
      :to="'/cellosign-iframe/exception-committee/' + $route.params.id"
    >
      <SendIcon class="action-icon" />הגשה לוועדת חריגים
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RescheduleIcon from "@/assets/img/svg/actions/reschedule.svg";
import TrashIcon from "@/assets/img/svg/actions/trash.svg";
import EditIcon from "@/assets/img/svg/actions/edit.svg";
import FileAddIcon from "@/assets/img/svg/actions/file-add.svg";
import ClipboardListIcon from "@/assets/img/svg/actions/clipboard-list.svg";
import FileCheckIcon from "@/assets/img/svg/actions/file-check.svg";
import SendIcon from "@/assets/img/svg/actions/send.svg";
import { EXCEPTION_COMMITTEE_ENABLED } from "../../../../utilities/feature-flags.js";

export default {
  name: "ApproveActions",
  props: ["surgStartDate", "surgBeforeToday"],
  components: {
    RescheduleIcon,
    TrashIcon,
    EditIcon,
    FileAddIcon,
    ClipboardListIcon,
    FileCheckIcon,
    SendIcon
  },
  computed: {
    ...mapGetters(["showIVF"]),
    showExceptionCommittee() {
      return EXCEPTION_COMMITTEE_ENABLED;
    }
  }
};
</script>
<style scoped>
/* Uniform icon system: one style, one size for every action. */
.action-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-left: 7px;
  color: #324997;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
